import classNames from 'classnames';
import { useState } from 'react';

import { useCartContext } from '@zooplus/cart-provider';
import { PrimaryButton, SecondaryButton } from '@zooplus/ui-components';

import { useWindowSize } from '../../../hooks/useWindowsSize';
import { PremiumAddedModal } from '../PremiumAddedModal/PremiumAddedModal';

import PremiumPuppy from './premium-puppy.png';
import styles from './PremiumBanner.module.css';

export interface PremiumBannerProps {
  programLogo?: React.ReactElement;
  title: string;
  subtitle: string | React.ReactElement;
  primaryButtonText: string;
  onPrimaryButtonClick: () => Promise<void>;
  secondaryButtonText: string;
  onSecondaryButtonClick: () => void;
  rounded?: boolean;
}

export const PremiumBanner = ({
  programLogo,
  title,
  subtitle,
  primaryButtonText,
  onPrimaryButtonClick,
  secondaryButtonText,
  onSecondaryButtonClick,
  rounded = false,
}: PremiumBannerProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHandlingPrimaryClick, setIsHandlingPrimaryClick] = useState(false);
  const { cart } = useCartContext();
  const isCartEmpty = cart?.articles?.length === 0;
  const { innerWidth } = useWindowSize();

  const handlePrimaryButtonClick = async () => {
    setIsHandlingPrimaryClick(true);
    try {
      await onPrimaryButtonClick();
      setIsModalOpen(true);
    } finally {
      setIsHandlingPrimaryClick(false);
    }
  };
  return (
    <>
      <div
        data-testid="premium-banner"
        className={classNames({ [styles.banner]: true, [styles.rounded]: rounded })}>
        <div className={styles.content}>
          {programLogo}
          <h2 className={styles.title}>{title}</h2>
          <div data-testid="subtitle" className={styles.subtitle}>
            {subtitle}
          </div>
          <div className={styles.buttonsContainer}>
            <PrimaryButton
              data-testid="primary-button"
              className={styles.primaryButton}
              onClick={handlePrimaryButtonClick}
              isLoading={isHandlingPrimaryClick}
              length={innerWidth < 768 ? 'full' : undefined}>
              {primaryButtonText}
            </PrimaryButton>
            <SecondaryButton
              data-testid="secondary-button"
              className={styles.secondaryButton}
              onClick={onSecondaryButtonClick}
              length={innerWidth < 768 ? 'full' : undefined}>
              {secondaryButtonText}
            </SecondaryButton>
          </div>
        </div>
        <img src={PremiumPuppy} className={styles.image} alt="" aria-hidden />
      </div>
      <PremiumAddedModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        isCartEmpty={isCartEmpty}
      />
    </>
  );
};
